import { useCallback, useState } from 'react';

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = useCallback(async ({ endpoint, method = 'GET', body, headers = {} }) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        body: body ? JSON.stringify(body) : undefined,
      });

      if (!response.ok) {
        const err = new Error('Request failed');
        try {
          err.responseData = await response.json();
        } catch {
          err.responseData = { error: `서버 오류 (${response.status})` };
        }
        err.status = response.status;
        throw err;
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, loading, error };
};

export default useApi;


